import React from "react";

const SwitchButton = ({ value, onChange, wrapperClassName, title, name }) => {
  return (
    <div className={`flex items-center gap-x-8 ${wrapperClassName}`}>
      <label class="switch">
        <input type="checkbox" name={name} onChange={onChange} checked={value} />
        <span class="slider round"></span>
      </label>
      {title ? <div className="font-size-medium">{title}</div> : null}
    </div>
  );
};

export default SwitchButton;
